import React from 'react';
import { motion } from 'framer-motion';
import './RehabilitacionReadaptacion.css';

export default function RehabilitacionReadaptacion() {
  // Modalidades disponibles
  const modalidades = [
    "Opción ilimitada o 2 días a la semana",
    "Planificación personal (máximo grupos de 3 personas)"
  ];

  // Datos de precios con detalles en cada opción
  const precios = [
    {
      precio: "280€",
      titulo: "2 días a la semana",
      detalles: [
        "Valoraciones funcionales",
        "2 entrenamientos o sesiones de fisioterapia por semana",
        "Planificación diaria (online)"
      ]
    },
    {
      precio: "360€",
      titulo: "Ilimitada",
      detalles: [
        "Valoraciones funcionales",
        "Sesiones ilimitadas (según criterio del profesional y necesidades del proceso lesivo)",
        "Planificación diaria (online)",
        "Uso libre de instalaciones",
        "Cesión gratuita de maquinaria",
        "Sesiones de readaptación específica en campo/pista"
      ]
    }
  ];

  return (
    <div className="rehab-container">
      {/* Título animado */}
      <motion.h1 
        className="rehab-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        REHABILITACIÓN Y READAPTACIÓN
      </motion.h1>

      {/* Descripción */}
      <motion.p 
        className="rehab-description"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        Rehabilitación funcional de lesiones y readaptación progresiva al esfuerzo y a la práctica deportiva.
      </motion.p>

      {/* Recomendado para */}
      <motion.div 
        className="rehab-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <h2>Recomendado para</h2>
        <p>
          Personas que sufran un proceso lesivo y quieran realizar un proceso rehabilitador temprano basado en la evidencia científica.
        </p>
      </motion.div>

      {/* Modalidades */}
      <motion.div 
        className="rehab-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Modalidades</h2>
        <ul className="rehab-list">
          {modalidades.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </motion.div>

      {/* Sección de Precios */}
      <motion.div 
        className="rehab-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        <h2>Precios</h2>
        <div className="rehab-precios">
          {precios.map((item, index) => (
            <div key={index} className="rehab-precio-cell">
              <p className="rehab-precio">{item.precio}</p>
              <p className="rehab-titulo">{item.titulo}</p>
              <ul className="rehab-detalles">
                {item.detalles.map((detalle, i) => (
                  <li key={i}>{detalle}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="rehab-note">Precios por persona al mes.</p>
      </motion.div>
    </div>
  );
}
